import React, { useRef } from 'react';

import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

import CiCWorkflowStages from 'common/Workflows/CiCWorkflowStages';

const isClosed = stage => stage === CiCWorkflowStages.Complete || stage === CiCWorkflowStages.Closed;

const isExpertReview = stage => stage === CiCWorkflowStages.PendingExpertReview || stage === CiCWorkflowStages.UnderExpertReview;

/* eslint-disable react/prop-types, react/no-unstable-nested-components */
const CicActions = ({ permissions, takeAlert }) => ({
  id: 'action-column',
  Header: <span className="expand-header-offset">View</span>,
  Cell: ({ row }) => {
    const refButton = useRef(null);
    return (<div className="form-action-btn-group">
      { row.original && (
        (!isClosed(row.original.workflowStage) && AccessControl.hasPermission(permissions, [ActivityPerms.monitoringResolver]))
        || (isClosed(row.original.workflowStage) && AccessControl.hasPermission(permissions, [ActivityPerms.monitoringViewResolved]))
        || (isExpertReview(row.original.workflowStage) && AccessControl.hasPermission(permissions, [ActivityPerms.monitoringExpertReviewer])))
        && <button
          className="btn btn-sm "
          type="button"
          ref={ refButton }
          onClick={ () => {
            refButton.current.blur();
            takeAlert(row.original);
          } }
          title="Show Alert Details"
        >
          <span className="icon icon-apps" />
        </button> }
    </div>);
  }
});
/* eslint-enable react/prop-types, react/no-unstable-nested-components */

export default CicActions;
